module.exports = __webpack_public_path__ + "components/flag/static/square/sl-29921231b419d01d6d6b11c9d4f5bbfb.svg";